// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { DateRangeFilter } from '@coa/app/shared/filters/select-date-range/models/date-range-filter';

@Component({
  selector: 'coa-dashboard-floors-show-all',
  templateUrl: './dashboard-floors-show-all.component.html',
  styleUrls: ['./dashboard-floors-show-all.component.scss'],
})
export class DashboardFloorsShowAllComponent {
  @Input() clientId: string;
  @Input() dateRange: DateRangeFilter;
  @Input() categoryId: string;

  constructor(
    private router: Router,
  ) {
  }

  showAll(): void {
    this.router.navigate(['/clients', this.clientId, 'floors'], {
      queryParams: {
        dateRange: this.dateRange,
        categoryId: this.categoryId,
      },
    });
  }
}
